import React, { useEffect } from "react";
import "./commonAnimtion.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  carImg26,
  goldCoins,
  goldCoinsCards,
  grandPrizeIcon26,
  grandPrizeIcon26Mob,
  leftAnimationImg,
  leftAnimationImgMob,
} from "../../../images";
import { useWindowSize } from "react-use";

gsap.registerPlugin(ScrollTrigger);

const CommonAnimtion = ({ playImmediately = false }) => {
  const { width } = useWindowSize();
  useEffect(() => {
    gsap.to(".gif_flip", {
      scrollTrigger: playImmediately
        ? null
        : {
            trigger: ".gif_flip",
            start: "top 80%",
          },
      rotateY: 360,
      duration: 3,
      ease: "power2.inOut",
    });

    gsap.fromTo(
      ".main_car",
      {
        x: "100vw", // Start off-screen to the right
      },
      {
        scrollTrigger: playImmediately
          ? null
          : {
              trigger: ".common_strip--animtion",
              start: "top 90%",
            },
        x: 0,
        duration: 1,
        ease: "power2.out",
      },
    );

    // Left Side Items Animation
    gsap.fromTo(
      ".left img",
      {
        x: "-50vw", // Start off-screen to the left
        opacity: 0,
      },
      {
        scrollTrigger: playImmediately
          ? null
          : {
              trigger: ".common_strip--animtion",
              start: "top 90%",
            },
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
      },
    );

    // Gold Coins Animation
    gsap.fromTo(
      ".gold_coins",
      {
        y: 50,
        opacity: 0,
        scale: 0.8,
      },
      {
        scrollTrigger: playImmediately
          ? null
          : {
              trigger: ".common_strip--animtion",
              start: "top 90%",
            },
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.8,
        delay: 0.5, // starts slightly after car
        ease: "back.out(1.7)",
      },
    );

    // Gift Cards Animation
    gsap.fromTo(
      ".gold_coins_card",
      {
        y: 50,
        opacity: 0,
        scale: 0.8,
        rotation: -15,
      },
      {
        scrollTrigger: playImmediately
          ? null
          : {
              trigger: ".common_strip--animtion",
              start: "top 90%",
            },
        y: 0,
        opacity: 1,
        scale: 1,
        rotation: 0,
        duration: 0.6,
        delay: 0.6, // starts slightly after coins
        ease: "back.out(2)",
      },
    );
  }, [playImmediately]);

  return (
    <div className="common_strip--animtion">
      <div className="left">
        <img
          src={width > 767 ? leftAnimationImg : leftAnimationImgMob}
          alt="diwali"
        />
      </div>
      <div className="right">
        <img src={goldCoins} alt="diwali" className="gold_coins" />
        <img src={carImg26} alt="diwali" className="main_car" />
        <div className="gif_flip">
          <img
            src={width > 767 ? grandPrizeIcon26 : grandPrizeIcon26}
            alt="diwali"
            className="grand_prize_icon"
          />
        </div>
        <img src={goldCoinsCards} alt="diwali" className="gold_coins_card" />
      </div>
    </div>
  );
};

export default CommonAnimtion;
